import { Button, Col, Collapse, Form, Input, Modal, notification, Row, Spin, Tooltip, Switch } from "antd";
import { FormComponentProps } from "antd/lib/form";
import DataGrid, { Column, FilterRow, Grouping, GroupPanel, HeaderFilter, Pager, Paging, Selection } from "devextreme-react/data-grid";
import * as React from "react";
import { FormEvent, useContext, useState } from "react";
import { RouteComponentProps, withRouter, Redirect } from "react-router";
import { ParagraphMedium } from "src/components/common/Paragraphs/Paragraphs";
import { PbrCard } from "src/components/common/PbrCard/PbrCard";
import { PbrInput } from "src/components/common/PbrInput/PbrInput";
import { useEffect } from "src/ReactTS";
import { ServiceContext } from "src/services/provider/Service.provider";
import { cpfCnpjValidator } from "src/util/cpfCnpjValidator";
import { CpfCnpjMask } from "src/util/Masks/CpfCnpjMask";
import { MoneyMask } from "src/util/Masks/MoneyMask";
import { PercentageMask } from "src/util/Masks/PercentageMask";
import "./consult.scss";
import "./PbrInput.scss";
import { ShowNotification } from "src/components/common/ShowNotification/ShowNotification";
import { IQuote } from "src/services/interfaces/trade/precificacao/IQuote";
import { SelectCourtAndCourtType } from "src/components/common/SelectCourtTypeCourtCorrectionType/SelectCourtAndCourtType";
import { BirthDateComponent } from "src/components/PricingComponents/BirthDateComponent/BirthDateComponent";
import * as moment from "moment";
import { Moment } from "moment";
import { FoundPrecatorioStatusEnum } from "src/services/Enum/dap/FoundPrecatorioStatusEnum";
import { IPrecatorioDapResponse } from "src/services/interfaces/IPrecatorioDapResponse";
import { GetPersonType, PersonTypeEnum } from "src/util/GetPersonType";
import { PbrFormItem } from 'src/components/common/PbrFormItem/PbrFormItem';
import { IFeatureToggleConfig } from 'src/services/interfaces/IFeatureToggleConfig';

function MonitorPrecatoriosConsult(props: RouteComponentProps<any> & FormComponentProps) {
    const { precatorioService, quoteService, documentService, commonDomainService } = useContext(ServiceContext);
    const moneyMask = (params: any) => MoneyMask(params.value!);

    const [featureToggle, setFeatureToggle] = useState<IFeatureToggleConfig>(undefined)
    const [cpfOrCnpj, setCpfOrCnpj] = useState("");
    const [processCode, setProcessCode] = useState<string>(undefined);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [activePanel, setActivePanel] = useState("1");
    const [quote, setQuote] = useState<IQuote>(null);
    const [invalidCpfCnpj, setInvalidCpfCnpj] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const [birthDate, setBirthDate] = useState<Moment>(undefined);
    const [isSeriousIllness, setIsSeriousIllness] = useState(false);

    const [courtTypeId, setCourtTypeId] = useState<number>(null);
    const [courtId, setCourtId] = useState<number>(null);

    const [isSelectRequired, setIsSelectRequired] = useState(false);
    const [isQuoteDisable, setIsQuoteDisable] = useState(false);

    async function fetch(cpfParam: string, params = {}) {
        setLoading(true);
        try {
            const dapResponse = await precatorioService.postFindDap({ documentNumber: cpfParam, court: courtId, processCode, birthdate: birthDate });
            const precatorios = dapResponse.precatorios;
            setIsQuoteDisable(dapResponse.isNegotiating);
            setData(precatorios);
            if (precatorios.length === 0) {
                return ShowNotification.Warn("Nenhum precatorio encontrado", "A busca nao retornou resultados");
            } else {
                if (dapResponse.isNegotiating) {
                    return ShowNotification.Warn("Atenção!", dapResponse.message);
                }
            }
        } catch (error) {
            notification.error({
                message: "Falha na consulta",
                description: "Ocorreu um erro durante a consulta. Tente novamente."
            });
            setData([]);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        commonDomainService.getFeatureToggleConfig().then(setFeatureToggle).catch(console.error)
        const cpfRouter = (props.match.params as any).cpf;
        setActivePanel("1");
        if (cpfRouter) {
            setCpfOrCnpj(cpfRouter);
            handleTableChange(cpfRouter);
        }
    }, []);

    useEffect(() => {
        if (processCode) {
            setIsSelectRequired(true);
        } else {
            setIsSelectRequired(false);
        }
    }, [processCode]);

    const downloadProxy = (fileUrl: string, processCodeProxy: string) => documentService.proxyDownload(fileUrl, `Oficio_${processCodeProxy}.pdf`)

    function handleTableChange(cpfParam: string) {
        fetch(cpfParam);
    }

    function showQuote(p: IPrecatorioDapResponse) {
        setLoading(true);
        quoteService
            .postSaveQuoteDap({ ...p, birthDate, isSeriousIllness })
            .then(result => {
                setQuote(result);
                setRedirect(true);
            })
            .catch(err => {
                notification.error({
                    description: err?.response?.data?.message ?? "Não foi possível realizar a cotação",
                    message: "Erro ao realizar a cotação"
                });
            })
            .finally(() => setLoading(false));
    }

    const clearFields = () => {
        setCourtTypeId(null);
        setCourtId(null);
        setCpfOrCnpj(null);
        setProcessCode(null);
        setBirthDate(moment());

        props.form.setFieldsValue({
            ddlType: "",
            ddlCourt: "",
            processCode: ""
        });
    };

    async function handleSubmit(e: FormEvent) {
        e.preventDefault();

        props.form.validateFields(async (err, values) => {
            if (!err) {
                if (!cpfCnpjValidator(cpfOrCnpj) && !processCode) {
                    return notification.warn({
                        message: "Consulta inválida",
                        description: "Por favor, informe o CPF/CNPJ ou Número do Precatório."
                    });
                }
                handleTableChange(cpfOrCnpj);
            }
        });
    }

    return (
        <Spin spinning={loading}>
            {redirect && <Redirect to={{ pathname: `/monitor/cotacoes/${quote.id}`, state: { from: props.location } }} />}
            <PbrCard className="consult" title="Consulte precatórios" bordered={false} style={{ width: "100%" }}>
                <Form onSubmit={e => handleSubmit(e)}>
                    <Collapse bordered={false} destroyInactivePanel activeKey={activePanel}>
                        <Collapse.Panel style={{ border: "none" }} header="" key="1" showArrow={false}>
                            <Row style={{ textAlign: "right", marginBottom: "15px" }}>
                                <Col xs={24} sm={24} md={{ span: 1, offset: 23 }} lg={{ span: 1, offset: 23 }}>
                                    <Tooltip title="Limpar formulário">
                                        <Button
                                            ghost
                                            onClick={() => {
                                                Modal.confirm({
                                                    title: "Deseja realmente limpar o formulário?",
                                                    onOk: () => clearFields()
                                                });
                                            }}
                                            type="primary"
                                            loading={loading}
                                            shape="circle"
                                            icon="delete"
                                            className={"button-calculator"}
                                            size="large"
                                            style={{
                                                fontSize: "20px",
                                                color: "#c42819",
                                                borderColor: "#c42819"
                                            }}
                                        />
                                    </Tooltip>
                                </Col>
                            </Row>
                            <Row gutter={30}>
                                <Col xs={8} sm={8} md={8} lg={8}>
                                    <div className="pbr-standard-input">
                                        <ParagraphMedium
                                            style={{
                                                marginBottom: "18px",
                                                fontSize: "16px"
                                            }}
                                        >
                                            CPF / CNPJ
                                        </ParagraphMedium>
                                        <Input
                                            value={cpfOrCnpj}
                                            onChange={e => {
                                                const maskedValue = CpfCnpjMask(e.target.value);
                                                setCpfOrCnpj(maskedValue);
                                                if (cpfCnpjValidator(e.target.value.substring(0, 18))) {
                                                    setInvalidCpfCnpj(false);
                                                } else {
                                                    setInvalidCpfCnpj(true);
                                                }
                                            }}
                                            name="cpfCnpj"
                                            placeholder="Digite o CPF/CNPJ"
                                        />
                                        <span style={{ color: "red", paddingLeft: "5px" }}>{invalidCpfCnpj ? "CPF/CNPJ Inválido" : ""}</span>
                                    </div>
                                </Col>
                                {GetPersonType(cpfOrCnpj) === PersonTypeEnum.PF &&
                                    <>
                                        {featureToggle?.activateBirthDate ?
                                            <Col xs={8} sm={8} md={8} lg={8}>
                                                <BirthDateComponent
                                                    name="birthDate"
                                                    request={birthDate}
                                                    onChange={setBirthDate}
                                                    form={props.form}
                                                    label="Data de nascimento do Requerente"
                                                    required
                                                />
                                            </Col> :
                                            <></>}
                                        {featureToggle?.activateSeriousIllness ?
                                            <Col xs={8} sm={8} md={8} lg={8}>
                                                <PbrFormItem label="Possui doença grave?" required>
                                                    <Switch
                                                        checkedChildren="Sim"
                                                        unCheckedChildren="Não"
                                                        checked={isSeriousIllness}
                                                        onChange={setIsSeriousIllness}
                                                    />
                                                </PbrFormItem>
                                            </Col> :
                                            <></>}
                                    </>}
                            </Row>
                            <Row gutter={30}>
                                <Col xs={8} sm={8} md={8} lg={8}>
                                    <PbrInput
                                        name="processCode"
                                        value={processCode}
                                        formItemProps={{ label: "Número do Precatório" }}
                                        placeholder="Informe o Número do Precatório"
                                        onChange={e => setProcessCode(e.target.value)}
                                        formWrapper={props.form}
                                    />
                                </Col>
                                <SelectCourtAndCourtType
                                    filledFields={false}
                                    colLgSize={4}
                                    colMdSize={4}
                                    courtTypeId={courtTypeId}
                                    onChangeCourtType={setCourtTypeId}
                                    courtId={courtTypeId}
                                    onChangeCourt={setCourtId}
                                    showCorrectionType={false}
                                    isTypeRequired={isSelectRequired}
                                    isCourtRequired={isSelectRequired}
                                    form={props.form}
                                />

                                <Col xs={12} sm={12} md={1} lg={1} style={{ paddingTop: "45px" }}>
                                    <Tooltip title="Buscar precatórios">
                                        <Button htmlType="submit" icon="search" />
                                    </Tooltip>
                                </Col>
                            </Row>

                            <div className="consult-results">
                                <DataGrid
                                    dataSource={data}
                                    allowColumnReordering={true}
                                    showBorders={true}
                                    loadPanel={{ enabled: loading }}
                                    rowAlternationEnabled={true}
                                    hoverStateEnabled={true}
                                    columnAutoWidth={true}
                                >
                                    <GroupPanel visible={true} />
                                    <Grouping autoExpandAll={true} />
                                    <Selection mode={"multiple"} selectAllMode={true} showCheckBoxesMode={true} />
                                    <FilterRow visible={true} />
                                    <HeaderFilter visible={true} />

                                    <Column
                                        caption="#"
                                        alignment={"center"}
                                        width={"100px"}
                                        cellRender={params =>
                                            <Tooltip title={params.data.message === null ? "Calcular Precatório" : params.data.message}>
                                                <Button
                                                    icon="calculator"
                                                    style={params.data.foundPrecatorioStatus !== FoundPrecatorioStatusEnum.FOUND_VALID_PRECATORIO ?
                                                        { color: "white", backgroundColor: "#808080" } :
                                                        undefined}
                                                    disabled={params.data.foundPrecatorioStatus !== FoundPrecatorioStatusEnum.FOUND_VALID_PRECATORIO || isQuoteDisable}
                                                    onClick={() => showQuote(params.data)}
                                                />
                                            </Tooltip>}
                                    />


                                    <Column
                                        caption="#"
                                        alignment={"center"}
                                        dataField="urlProcess"
                                        dataType="string"
                                        width={"auto"}
                                        cellRender={params => {
                                            return (
                                                <>
                                                    <a href={params.data.urlProcess} target={"_blank"}>
                                                        {params.data.urlProcess === null ? (
                                                            <Button icon="link" disabled={true} />
                                                        ) : (
                                                                <Tooltip title="Ir ao Site do Tribunal">
                                                                    <Button icon="link" />
                                                                </Tooltip>
                                                            )}
                                                    </a>
                                                </>
                                            );
                                        }}
                                    />

                                    <Column
                                        caption="#"
                                        alignment={"center"}
                                        dataField="urlProcessFile"
                                        dataType="string"
                                        width={"auto"}
                                        cellRender={params => (
                                            params.data.urlProcessFile === null ? (
                                                <Button icon="link" disabled />
                                            ) : (
                                                    <Tooltip title="Baixar PDF">
                                                        <Button icon="file-pdf" onClick={() => downloadProxy(params.data.urlProcessFile, params.data.processCode)} />
                                                    </Tooltip>
                                                )
                                        )}
                                    />
                                    <Column caption="Tipo" alignment={"center"} dataField="type.name" dataType="string" />
                                    <Column caption="Tribunal" alignment={"center"} dataField="court.name" dataType="string" />
                                    <Column caption="Processo" alignment={"center"} dataField="processCode" dataType="string" />
                                    <Column caption="Requerente" alignment={"center"} dataField="requester" dataType="string" />
                                    <Column caption="CPF/CNPJ" alignment={"center"} dataField="cpfCnpj" dataType="string" />
                                    <Column caption="Data Base" alignment={"center"} dataField="baseDate" dataType="date" format={"dd/MM/yyyy"} />
                                    <Column caption="Data Expedição" alignment={"center"} dataField="issueDate" dataType="date" format={"dd/MM/yyyy"} />
                                    <Column
                                        caption="Percentual do Credor"
                                        alignment={"center"}
                                        dataField="reducedPercentLender"
                                        dataType="number"
                                        cellRender={params => {
                                            return PercentageMask(params.data.reducedPercentLender === null ? 1 : params.data.reducedPercentLender, 2, 2);
                                        }}
                                    />
                                    <Column caption="Principal" alignment={"center"} dataField="principal" dataType="number" cellRender={moneyMask} />
                                    <Column caption="Juros" alignment={"center"} dataField="interest" dataType="number" cellRender={moneyMask} />
                                    <Column caption="Pss" dataField="isPss" dataType="boolean" alignment="center" />
                                    <Column caption="Ativo" dataField="active" dataType="boolean" alignment="center" />
                                    <Pager allowedPageSizes={[5, 10, 25, 50, 100]} showPageSizeSelector={true} />
                                    <Paging defaultPageSize={5} />
                                </DataGrid>
                            </div>
                        </Collapse.Panel>
                    </Collapse>
                </Form>
            </PbrCard>
        </Spin>
    );
}

export default withRouter(Form.create()(MonitorPrecatoriosConsult));



// WEBPACK FOOTER //
// ./src/pages/monitor/precatorios/MonitorPrecatoriosConsult.tsx